import * as Yup from 'yup';

const phoneNumberRegex = /^[1-9]{1}[0-9]{3,14}$/;

// regex for all us and canadian postal codes including zip+4 and UK

const noSpecialCharRegex = /^[a-zA-Z0-9\s]+$/;

const createStringValidation = () => Yup.string();

const createEmailValidation = () => Yup.string().email();

const createPasswordValidation = () =>
    Yup.string().min(8, 'Password must be at least 8 characters');

const createMatchingStringValidation = (referencedKey, label) =>
    Yup.string().oneOf(
        [Yup.ref(referencedKey)],
        `Must match ${label ?? referencedKey}`
    );

const createPhoneValidation = () =>
    Yup.string().matches(
        phoneNumberRegex,
        'Phone must be 4 - 15 digits and not start with 0.'
    );

const createAddressValidation = () =>
    Yup.object().shape({
        address: Yup.string().required('Address is required'),
        city: Yup.string()
            .required('City is required')
            .min(2, 'City must be at least 2 characters'),
        stateProvince: Yup.string()
            // Conditionally required based on country
            .when('country', {
                is: (country) => ['United States', 'Canada', 'Australia', 'India', 'Brazil', 'Mexico'].includes(country),
                then: (schema) => schema.required('State/Province is required')
                    .matches(noSpecialCharRegex, 'No special characters allowed'),
                otherwise: (schema) => schema.notRequired()
            }),
        postalCode: Yup.string().required('Postal Code is required'),
        country: Yup.string().required('Country is required'),
    });

const createCompanyValidation = () =>
    Yup.object().shape({
        ID: Yup.string(),
        Name: Yup.string(),
        Email: Yup.string().email(),
    });

const getValidationSchema = (fieldKeyString) => {
    const confirmEmailCases = [
        'confirmCustomerEmail',
        'confirmInstallerEmail',
        'confirmEmail',
    ];
    let confirmEmailCase = null;

    confirmEmailCases.forEach((caseStr) => {
        if (fieldKeyString?.includes(caseStr)) {
            confirmEmailCase = caseStr;
        }
    });
    switch (true) {
        case fieldKeyString.toLowerCase().includes('email') &&
            !fieldKeyString.includes('confirm'):
            return createEmailValidation();
        case confirmEmailCase !== null: // for any confirm email field
            let fieldKey = confirmEmailCase.replace('confirm', '');
            fieldKey = fieldKey.charAt(0).toLowerCase() + fieldKey.slice(1);
            const fieldName =
                fieldKey.replace('Email', ' Email').charAt(0).toUpperCase() +
                fieldKey.replace('Email', ' Email').slice(1);
            return createMatchingStringValidation(fieldKey, fieldName);
        case fieldKeyString.includes('password'):
            return createPasswordValidation();
        case fieldKeyString.includes('confirmPassword'):
            return createMatchingStringValidation('password');
        case fieldKeyString.includes('phone'):
            return createPhoneValidation();
        case fieldKeyString.includes('address'):
            return createAddressValidation();
        case fieldKeyString === 'company':
            return createCompanyValidation();
        default:
            return createStringValidation();
    }
};

export default getValidationSchema;
